// Auto-select 100ml variant on page load (only if no variant parameter in URL)
(function() {
  'use strict';
  
  // Only run once
  let hasRun = false;
  
  function autoSelect100ml() {
    if (hasRun) return;
    
    // Check if the feature is enabled via theme settings
    const enableAutoSelect = document.body.getAttribute('data-enable-auto-select-100ml');
    if (enableAutoSelect === 'false' || !enableAutoSelect || enableAutoSelect === '') {
      console.log('[Auto-select 100ml] Feature is disabled in theme settings');
      return;
    }
    
    // Check if there's already a variant parameter in the URL
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('variant')) {
      console.log('[Auto-select 100ml] Variant already specified in URL, skipping auto-selection');
      return;
    }
    
    // Find the variant-selects element
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) {
      console.log('[Auto-select 100ml] No variant-selects element found');
      return;
    }
    
    // Look for inputs (radio buttons, checkboxes) or select options containing "100ml" or "100"
    let found100ml = false;
    
    // Try radio buttons first (most common for size selection)
    const radioInputs = variantSelects.querySelectorAll('input[type="radio"]');
    for (const input of radioInputs) {
      const value = input.value.toLowerCase();
      if ((value.includes('100ml') || value.includes('100 ml') || value === '100') && !input.disabled && !input.classList.contains('disabled')) {
        // Check if this variant is available
        const label = input.closest('label') || document.querySelector(`label[for="${input.id}"]`);
        const isDisabled = label && label.textContent.includes('unavailable');
        
        if (!isDisabled) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          console.log('[Auto-select 100ml] Selected 100ml variant:', input.value);
          found100ml = true;
          break;
        }
      }
    }
    
    // If no radio button found, try select dropdowns
    if (!found100ml) {
      const selects = variantSelects.querySelectorAll('select');
      for (const select of selects) {
        const options = select.querySelectorAll('option');
        for (const option of options) {
          const value = option.value.toLowerCase();
          if ((value.includes('100ml') || value.includes('100 ml') || value === '100') && !option.disabled) {
            option.selected = true;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            console.log('[Auto-select 100ml] Selected 100ml variant from dropdown:', option.value);
            found100ml = true;
            break;
          }
        }
        if (found100ml) break;
      }
    }
    
    if (found100ml) {
      hasRun = true;
    } else {
      console.log('[Auto-select 100ml] No 100ml variant found or available');
    }
  }
  
  // Try to run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoSelect100ml);
  } else {
    // DOM is already ready, run immediately
    autoSelect100ml();
  }
  
  // Also try after a small delay to ensure all components are initialized
  setTimeout(autoSelect100ml, 100);
})();

